import { Optional } from '@pogokid/util'
import { getPublicConfig } from '~/config.ts'

export function signinPath() {
  return '/signin'
}

export function signoutPath() {
  return '/signout'
}

export function signinPathWithReturnTo(
  returnUrl: Optional<string>
) {
  if (typeof returnUrl === 'string') {
    return `${signinPath()}?return_to=${returnUrl}`
  } else {
    return signinPath()
  }
}

export function signoutCompleteReturnToPath() {
  return getPublicConfig().callbackBaseUrl + '/signout'
}

export function isSignout() {
  return (
    typeof location !== 'undefined' &&
    location.pathname === signoutPath()
  )
}
